import { useMatter } from "../../../contexts/MatterContext";
import { Divider } from "../../../design/divider";
import { Heading } from "../../../design/heading";

const AdminDashboardRecentWork = () => {
  const { matters } = useMatter();

  const recentMatters = [...matters]
    .sort(
      (a, b) =>
        new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime(),
    )
    .slice(0, 5);

  return (
    <div className="flex flex-col w-full p-6 space-y-4 bg-white shadow-lg rounded-2xl dark:bg-black">
      <Heading>Recent Work</Heading>
      <Divider />
      {recentMatters.length > 0 ? (
        <div className="flex flex-row space-x-4 overflow-x-auto">
          {recentMatters.map((matter) => (
            <div
              key={matter._id}
              className="flex flex-col min-w-[280px] p-4 border rounded-xl bg-gray-50 dark:bg-zinc-900 shadow-sm"
            >
              {/* Icon placeholder */}
              <div className="flex items-center justify-center w-10 h-10 mb-2 bg-blue-100 rounded-full">
                📄
              </div>

              {/* Title */}
              <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                {matter.name}
              </h2>

              {/* Subheader (Matter ID) */}
              <p className="mb-1 text-sm text-gray-500">
                Matter ID: {matter.name}
              </p>

              {/* Type */}
              <p className="mb-4 text-sm text-gray-500">
                Type: {matter.matterType || "General"}
              </p>

              {/* Owner */}
              <div className="flex items-center mt-auto space-x-2">
                {/* Avatar Placeholder */}
                <div className="w-8 h-8 bg-gray-300 rounded-full" />
                <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                  {matter.createdById || "Unknown"}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-gray-500">No recent work found.</p>
      )}
    </div>
  );
};

export default AdminDashboardRecentWork;
